/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_MotionInputs */

const en_svtag_motion = /** @type {(inputs: Svtag_MotionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MOTION`)
};

const ar_svtag_motion = /** @type {(inputs: Svtag_MotionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#حركة`)
};

const bn_svtag_motion = /** @type {(inputs: Svtag_MotionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MOTION`)
};

const de_svtag_motion = /** @type {(inputs: Svtag_MotionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MOTION`)
};

const es_svtag_motion = /** @type {(inputs: Svtag_MotionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MOTION`)
};

const fr_svtag_motion = /** @type {(inputs: Svtag_MotionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MOTION`)
};

const pt_svtag_motion = /** @type {(inputs: Svtag_MotionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MOTION`)
};

const zh_svtag_motion = /** @type {(inputs: Svtag_MotionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MOTION`)
};

const tr_svtag_motion = /** @type {(inputs: Svtag_MotionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MOTION`)
};

const ru_svtag_motion = /** @type {(inputs: Svtag_MotionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MOTION`)
};

const pl_svtag_motion = /** @type {(inputs: Svtag_MotionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MOTION`)
};

/**
* | output |
* | --- |
* | "#MOTION" |
*
* @param {Svtag_MotionInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_motion = /** @type {((inputs?: Svtag_MotionInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_MotionInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_motion(inputs)
	if (locale === "bn") return bn_svtag_motion(inputs)
	if (locale === "de") return de_svtag_motion(inputs)
	if (locale === "es") return es_svtag_motion(inputs)
	if (locale === "fr") return fr_svtag_motion(inputs)
	if (locale === "pt") return pt_svtag_motion(inputs)
	if (locale === "zh") return zh_svtag_motion(inputs)
	if (locale === "tr") return tr_svtag_motion(inputs)
	if (locale === "ru") return ru_svtag_motion(inputs)
	if (locale === "pl") return pl_svtag_motion(inputs)
	return en_svtag_motion(inputs)
});